import { useTypedSelector } from "../redux/store";

function useTaxiServices() {
	const taxiServices = useTypedSelector((state) => state.taxiServices.models);

	return taxiServices;
}

export default useTaxiServices;
